export const renderSkill = skill => {
  const { skillName, difficultyLevel } = skill;
  return `${skillName}${
    difficultyLevel !== 'General' ? ` (${difficultyLevel || ''})` : ''
  }`;
};
